export default __webpack_public_path__ + "static/media/denya_wood_1.93871758.png";